<template>
  <div id="dialog_table">
    <div class="content_content">
      <div class="tableData">
        <el-table
          ref="singleTable"
          :data="tableData"
          highlight-current-row
          height="98%"
          :header-cell-style="{
            background: ' rgba(240, 240, 240, 1)',
            color: '#000000',
          }"
        >
          <el-table-column width="55" type="selection" fixed> </el-table-column>
          <template
            ><el-table-column
              v-for="(item, index) in tableMenu"
              :property="item.key"
              :key="index"
              :label="item.name"
              :show-overflow-tooltip="item.key != 'isSelect'"
              :width="item.width"
              style="background-color: #eee"
            >
            </el-table-column>
          </template>
          <el-table-column label="审核结果" width="150">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row, 'pass')"
                type="text"
                size="small"
                >通过</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row, 'edit')"
                type="text"
                size="small"
                >编辑</el-button
              >
              <el-button
                @click="handleClick(scope.row, 'delete')"
                type="text"
                size="small"
                style="color: red"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pageSize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageData.currentPage"
          :page-size="pageData.pageSize"
          layout="total,sizes, prev, pager, next,jumper"
          :total="pageData.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      data: this.tableData,
    };
  },
  methods: {
    initTableData() {
      this.$emit("initTableData");
    },
  },
};
</script>

<style lang="less" scoped>
#dialog_table {
  width: 100%;
  height: 100%;
}
</style>
